import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Seo from "@/components/Seo";
export default function NotFound() {
  return (
    <>
      <Seo title="Pagina nu a fost găsită" noindex />
      <section className="wrap not-found">
        <span>404</span>
        <h1>Pagina nu a fost găsită</h1>
        <p>Pagina căutată nu există sau a fost mutată.</p>
        <Link className="button" to="/">
          Înapoi la pagina principală <ArrowUpRight size={19} />
        </Link>
      </section>
    </>
  );
}
